import { List, Image } from "@mantine/core";
import { ReactComponent as WSPayLogo } from "@/assets/ws-pay/ws-pay-logo.svg";
import VisaSecure from "@/assets/ws-pay/visa-secure.png";
import MastercardIdentityCheck from "@/assets/ws-pay/mastercard-identity-check.png";
import "./TermsAndPrivacy.css";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="terms-and-privacy-container">
      <div className="terms-and-privacy-title">
        Pravila zaštite osobnih podataka
      </div>
      <div className="terms-and-privacy-updated">
        Posljednje ažurirano: 6. svibnja 2025.
      </div>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Osnovna načela privatnosti tvrtke CoreEvent d.o.o.
        </div>
        <div className="terms-and-privacy-paragraph">
          Pravila zaštite osobnih podataka na internet stranicama
          www.drevija.gnkdinamo.hr zajedno s Općim uvjetima ugovora za kupce na
          internet stranicama www.drevija.gnkdinamo.hr predstavljaju pravnu
          cjelinu te pristupanjem i korištenjem Portala, Kupac prihvaća i daje
          svoju suglasnost na sam sadržaj navedenih Pravila i Općih uvjeta.
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent će obrađivati osobne podatke u skladu pozitivnim propisima
          Republike Hrvatske te u skladu s Uredbom (EU) 2016/679 Europskog
          parlamenta i Vijeća od 27. travnja 2016. o zaštiti pojedinaca u vezi s
          obradom osobnih podataka i o slobodnom kretanju takvih podataka te o
          stavljanju izvan snage Direktive 95/46/EZ (dalje: Opća uredba o
          zaštiti podataka).
        </div>

        <div className="terms-and-privacy-paragraph">
          Sukladno pozitivnim odredbama, u ovim Pravilima zaštite osobnih
          podataka na internet stranicama www.drevija.gnkdinamo.hr uređuju se
          slijedeći pravni termini:
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„osobni podaci"</strong> znače svi podaci koji se odnose na
          pojedinca čiji je identitet utvrđen ili se može utvrditi
          („ispitanik"); pojedinac čiji se identitet može utvrditi jest osoba
          koja se može identificirati izravno ili neizravno, osobito uz pomoć
          identifikatora kao što su ime, identifikacijski broj, podaci o
          lokaciji, mrežni identifikator ili uz pomoć jednog ili više čimbenika
          svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski,
          kulturni ili socijalni identitet tog pojedinca;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„obrada"</strong> znači svaki postupak ili skup postupaka koji
          se obavljaju na osobnim podacima ili na skupovima osobnih podataka,
          bilo automatiziranim bilo neautomatiziranim sredstvima kao što su
          prikupljanje, bilježenje, organizacija, strukturiranje, pohrana,
          prilagodba ili izmjena, pronalaženje, obavljanje uvida, uporaba,
          otkrivanje prijenosom, širenjem ili stavljanjem na raspolaganje na
          drugi način, usklađivanje ili kombiniranje, ograničavanje, brisanje
          ili uništavanje;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„izrada profila"</strong> znači svaki oblik automatizirane
          obrade osobnih podataka koji se sastoji od uporabe osobnih podataka za
          ocjenu određenih osobnih aspekata povezanih s pojedincem, posebno za
          analizu ili predviđanje aspekata u vezi s radnim učinkom, ekonomskim
          stanjem, zdravljem, osobnim sklonostima, interesima, pouzdanošću,
          ponašanjem, lokacijom ili kretanjem tog pojedinca;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„pseudonimizacija"</strong> znači obrada osobnih podataka na
          način da se osobni podaci više ne mogu pripisati određenom ispitaniku
          bez uporabe dodatnih informacija, pod uvjetom da se takve dodatne
          informacije drže odvojeno te da podliježu tehničkim i organizacijskim
          mjerama kako bi se osiguralo da se osobni podaci ne mogu pripisati
          pojedincu čiji je identitet utvrđen ili se može utvrditi;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„voditelj obrade"</strong> znači fizička ili pravna osoba,
          tijelo javne vlasti, agencija ili drugo tijelo koje samo ili zajedno s
          drugima određuje svrhe i sredstva obrade osobnih podataka; kada su
          svrhe i sredstva takve obrade utvrđeni pravom Unije ili pravom države
          članice, voditelj obrade ili posebni kriteriji za njegovo imenovanje
          mogu se predvidjeti pravom Unije ili pravom države članice;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„izvršitelj obrade"</strong> znači fizička ili pravna osoba,
          tijelo javne vlasti, agencija ili drugo tijelo koje obrađuje osobne
          podatke u ime voditelja obrade;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„primatelj"</strong> znači fizička ili pravna osoba, tijelo
          javne vlasti, agencija ili drugo tijelo kojem se otkrivaju osobni
          podaci, neovisno o tome je li on treća strana. Međutim, tijela javne
          vlasti koja mogu primiti osobne podatke u okviru određene istrage u
          skladu s pravom Unije ili države članice ne smatraju se primateljima;
          obrada tih podataka koju obavljaju ta tijela javne vlasti mora biti u
          skladu s primjenjivim pravilima o zaštiti podataka prema svrhama
          obrade;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„treća strana"</strong> znači fizička ili pravna osoba, tijelo
          javne vlasti, agencija ili drugo tijelo koje nije ispitanik, voditelj
          obrade, izvršitelj obrade ni osobe koje su ovlaštene za obradu osobnih
          podataka pod izravnom nadležnošću voditelja obrade ili izvršitelja
          obrade;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„privola" ispitanika</strong> znači svako dobrovoljno,
          posebno, informirano i nedvosmisleno izražavanje želja ispitanika
          kojim on izjavom ili jasnom potvrdnom radnjom daje pristanak za obradu
          osobnih podataka koji se na njega odnose;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„povreda osobnih podataka"</strong> znači kršenje sigurnosti
          koje dovodi do slučajnog ili nezakonitog uništenja, gubitka, izmjene,
          neovlaštenog otkrivanja ili pristupa osobnim podacima koji su
          preneseni, pohranjeni ili na drugi način obrađivani;
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„relevantni i obrazloženi prigovor"</strong> znači prigovor na
          nacrt odluke kao i na to je li došlo do kršenje ove Uredbe, ili je li
          djelovanje predviđeno u vezi s voditeljem obrade ili izvršiteljem
          obrade u skladu s ovom Uredbom, koji jasno pokazuje važnost rizika
          koje predstavlja nacrt odluke u pogledu temeljnih prava i sloboda
          ispitanika i, ako je primjenjivo, slobodnog protoka osobnih podataka
          unutar Unije;
        </div>

        <div className="terms-and-privacy-paragraph">
          Svi ostali termini koji su korišteni u ovim Pravilima su definirani
          odredbama Opće uredbe o zaštiti podataka te Općim uvjetima ugovora za
          treću stranu (kupce) na internet stranicama www.drevija.gnkdinamo.hr
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„CoreEvent"</strong> je trgovačko društvo registrirano po
          hrvatskom pravu pod nazivom tvrtke CoreEvent d.o.o. u sudskom registru
          Trgovačkog suda u Zagrebu pod OIB: 36611335369 i MBS: 081377997, sa
          sjedištem u Zagrebu, Dunjevac 15, koje temeljem ugovora o trgovinskom
          zastupanju s Organizatorom u ime i za račun Organizatora pregovara i
          sklapa ugovore o prodaji ulaznica s Kupcima (trećim osobama) u ime i
          za račun Organizatora kao nalogodavca, a nalogodavac kao Organizator
          se obvezuje da će CoreEvent-u kao zastupniku i nalogoprimcu za svaki
          ugovor kojega je CoreEvent sklopilo ili koji je sklopljen njegovim
          djelovanjem isplatiti naknadu određenu ugovorom o trgovinskom
          zastupanju.
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent je izvršitelj obrade u odnosu na osobne podatke određene od
          strane Organizatora kao voditelja obrade, dok u odnosu na osobne
          podatke za koje je ishođena zakonita i pravnoosnovana privola od
          strane Kupca, a čija svrha prikupljanja je određena od strane
          CoreEventa te je ishođena zakonita privola predstavlja voditelja
          obrade.
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent će osobne podatke koje je Kupac naveo prilikom postupka
          registracije spremit u svoje baze podataka te ih koristiti u obradama
          koje su nužne kako bi se izvršile ugovorne obveze prema Prodavatelju i
          Kupcu i u odnosu na osobne podatke te svrhu za koju je Kupac -
          ispitanik dao svoju privolu.
        </div>

        <div className="terms-and-privacy-paragraph">
          U odnosu na osobne podatke koji se obrađuju u svojstvu voditelja
          obrade ili izvršitelja obrade, iste se odnose i reguliraju na sljedeći
          način:
        </div>

        <List withPadding listStyleType="number">
          <List.Item className="terms-and-privacy-list-item">
            Vaše osobne podatke (ime i prezime, e-mail adresa) koristit ćemo
            isključivo za svrhu za koju smo od Vas zaprimili privolu te su isti
            nužan uvjet za sklapanje ugovora o prodaji ulaznice jer su iste
            nužne radi ispunjenje ugovornih obveza CoreEventa, Kupca i
            Prodavatelja
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Nećemo zloupotrebljavati Vaše osobne podatke na bilo koji način koji
            je suprotan Općoj uredbi o zaštiti osobnih podataka.
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Vaše kontakt i osobne podatke podijelit ćemo s Prodavateljem čiji
            Digitalni sadržaj kupujete.
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Na Vaš zahtjev omogućit ćemo Vam uvid u Vaše osobne podatke, obrade
            u kojima sudjeluju te Vam omogućiti ispravak osobnih podataka.
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Na Vaš zahtjev izbrisat ćemo sve Vaše osobne podatke koje smo
            spremili ukoliko posjedovanje istih nije regulirano zakonskom
            obvezom
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Na Vaš zahtjev, omogućiti povlačenje ranije dane privole za obradu
            osobnih podataka
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Sukladno pravima i obvezama Opće uredbe o zaštiti podataka,
            Kupac-ispitanik ima pravo na ispravak, pravo na brisanje, pravo na
            ograničenje obrade, pravo na prenosivost podataka, pravo na prigovor
            voditelju i/ili izvršitelju obrade te nadzornom tijelu, a koja prava
            se ostvaruju putem odgovarajućih obrazaca koji predstavljaju prilog
            ovim Pravilima zaštite osobnih podataka na internet stranicama
          </List.Item>
        </List>

        <div className="terms-and-privacy-paragraph">
          CoreEvent ne odgovara za slučajnu pogrešku ili pogrešku uzrokovanu
          višom silom ili drugim objektivnim razlozima kojim se uzrokuje
          nenamjerno kršenje zajamčene zaštite Vaših podataka, ali jamči da će
          pogreška, ukoliko je moguće biti otklonjena u najbržem mogućem roku.
        </div>

        <div className="terms-and-privacy-paragraph">
          Kupac upisom osobnih podataka na Portalu, potvrđuje kako je stariji od
          16 godina i potvrđuje kako stariji od 16 godina, poslovno sposobni i
          ovlašteni raspolagati danim podacima te Kupac potvrđuje kako su
          uneseni osobni podaci u potpunosti su točni kao da je Kupac suglasan
          da se podaci upotrebljavaju i prikupljaju u skladu sa zakonom i
          uvjetima naše Politike privatnosti te Općom uredbom o zaštiti
          podataka.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Kako koristimo Vaše osobne podatke
        </div>
        <div className="terms-and-privacy-paragraph">
          CoreEvent će osobne podatke koje je Kupac naveo prilikom postupka
          registracije spremit u svoje baze podataka te ih koristiti u obradama
          koje su nužne kako bi se izvršile ugovorne obveze prema Prodavatelju i
          Kupcu i u odnosu na osobne podatke te svrhu za koju je Kupac -
          ispitanik dao svoju privolu kao i u svrhu ispunjenja zakonskih obveza
          CoreEventa.
        </div>

        <div className="terms-and-privacy-paragraph">
          Svrha obrade osobnih podataka jest obrada osobnih podataka nužnih za
          sklapanje ugovora o prodaji s Prodavateljem te radi ispunjenja
          ugovornih obveza CoreEventa prema Prodavatelju te Prodavatelja prema
          Kupcu, a isti se čuvaju na razdoblje nužno za ispunjenje svih zakonski
          i ugovornih obveza odnosno najdulje 10 godina.
        </div>

        <div className="terms-and-privacy-paragraph">
          Obrada osobnih podataka u pogledu bankovnih podataka (broj kartice,
          datum važenja kartice i sl.) se ne pohranjuju niti obrađuju kod
          CoreEventa ili Prodavatelja već se isti procesiraju
          sigurnosnim-tehničkim sredstvima prema trećim stranama koje provode
          usluge online plaćanja (WSPay i sl.).
        </div>

        <div className="terms-and-privacy-paragraph">
          WSPay je siguran sustav za online plaćanje, plaćanje u realnom
          vremenu, kreditnim i debitnim karticama te drugim načinima plaćanja.
          WSPay kupcu i trgovcu osiguravaju siguran upis i prijenos upisanih
          podataka o karticama što podvrđuje i PCI DSS certifikat koji WSPay
          ima. WSPay koristi SSL certifikat 256 bitne enkripcije te TLS 1.2
          kriptografski protokol kao najviše stupnjeve zaštite kod upisa i
          prijenosa podataka.
        </div>

        <div className="flex gap-6 mb-6">
          <a
            href="http://www.wspay.info"
            title="Monri WSpay - Web Secure Payment Gateway"
            target="_blank"
          >
            <WSPayLogo height={40} />
          </a>
          <Image h={40} w="auto" src={MastercardIdentityCheck} />
          <Image h={40} w="auto" src={VisaSecure} />
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent će osobne podatke koje je Kupac unio u sustav Portala te u
          odnosu na danu svrhu i privolu Kupca-ispitanika, iste koristiti
          možebitno u sljedećem postupku izvršenja svojih zakonskih i/ili
          ugovornih obveza:
        </div>

        <List withPadding listStyleType="number">
          <List.Item className="terms-and-privacy-list-item">
            Kreiranje Vašeg profila u našoj bazi korisničkih računa, za slučaj
            da je Kupac-ispitanik u sustavu Portala zatražio takvo postupanje
            CoreEventa
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Evidentiranja podataka o kupnji, iznosu računa i načinu plaćanja
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Podrška za sve Vaše upite, komentare i sugestije, za slučaj da je
            Kupac-ispitanik u sustavu Portala zatražio takvo postupanje
            CoreEventa
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Prilikom plaćanja za kupljeni Digitalni sadržaj i/ili Pretplatu,
            Vaše podatke preusmjerit ćemo našim partnerima iz naplatnih sustava
            kako biste mogli uspješno izvršiti plaćanje.
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            Kada kupite Digitalni sadržaj i/ili Pretplatu, Vaše podatke
            podijelit ćemo sa Prodavateljem kako bi Vam bio osiguran kupljeni
            sadržaj
          </List.Item>
        </List>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
